var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27656 0.759977C5.21428 0.722771 5.14308 0.703125 5.07053 0.703125C4.99797 0.703125 4.92678 0.722771 4.86449 0.759977C4.81311 0.800684 4.77845 0.858817 4.76706 0.923368C4.75566 0.987919 4.76834 1.05441 4.80268 1.11024C6.0698 3.30453 6.33765 6.29206 4.60694 7.94035C3.94106 7.38077 3.41241 6.67591 3.06167 5.87998C2.42165 6.23545 1.89123 6.75945 1.528 7.3951C1.16478 8.03075 0.982618 8.75375 1.00131 9.48562C1.10982 12.1655 2.83503 14.1214 6.15222 14.1214C9.46941 14.1214 11.1898 12.0611 11.3031 9.48562C11.4371 6.39508 9.24276 2.5937 5.27656 0.759977Z",
    fill: "#0C0C0C",
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73224 9.48438C8.73224 10.0308 8.51517 10.5549 8.12877 10.9413C7.74238 11.3277 7.21832 11.5447 6.67188 11.5447",
    fill: "#0C0C0C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73224 9.48438C8.73224 10.0308 8.51517 10.5549 8.12877 10.9413C7.74238 11.3277 7.21832 11.5447 6.67188 11.5447",
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentIcon);
export default __webpack_public_path__ + "static/media/student-icon.a42e27f1687af34d88cc3abdf89a3dab.svg";
export { ForwardRef as ReactComponent };